import {useMemo} from 'react'
import {useMutation} from '@tanstack/react-query'
import {useDispatch} from 'react-redux'

import {useApi} from 'hooks'
import {setTermsConditionState} from 'redux/slices/termsCondition'

const useTermsCondition = () => {
  const api = useApi()
  const dispatch = useDispatch()

  const {data, mutate: getTermsCondition} = useMutation(api.getTermsCondition, {
    onSuccess: res => {
      dispatch(setTermsConditionState(res))
    },
  })

  const {mutate: submitTermsCondition, isLoading: submitTermsConditionLoading} = useMutation(
    () => api.postTermsCondition(data?.last_terms_id),
    {
      onSuccess: () => {
        getTermsCondition()
      },
    },
  )

  const isModalState = useMemo(() => {
    if (data?.show_terms_modal === 'yes') return true
    else return false
  }, [data])

  return {
    isModalState,
    getTermsCondition,
    submitTermsCondition,
    submitTermsConditionLoading,
  }
}

export default useTermsCondition
